import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from 'components/Loadable';

const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const OAuthCompletePage = Loadable(lazy(() => import('pages/auth/OAuthComplete')));

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Navigate to="/login" replace />
    },
    {
      path: 'login',
      element: <LoginPage />
    },
    {
      path: 'auth/oauth/complete',
      element: <OAuthCompletePage />
    }
  ]
};

export default LoginRoutes;
